import logoLightWhiz from '@/assets/images/logo-light-whiz.png';
import logoDarkWhiz from '@/assets/images/logo-dark-whiz.png';
import logoSvgWhiz from '@/assets/images/logo-whiz.svg';
import type { BrandingConfig } from './types';

export const whizBranding: BrandingConfig = {
  key: 'WHIZ',
  companyName: 'Whiz',
  shortName: 'Whiz',
  titles: {
    admin: 'Whiz - Ambiente Administrativo',
    user: 'Whiz - Gestão de Atendimento',
  },
  logo: {
    light: logoLightWhiz,
    dark: logoDarkWhiz,
    svg: logoSvgWhiz,
    iconLight: logoLightWhiz,
    iconDark: logoDarkWhiz,
  },
  favicon: logoSvgWhiz,
  themeColor: '#CE0271',
  // A Whiz é a única marca com o jogo completo de ícones em `public/img/icons`.
  pwaIcons: [
    { src: '/img/icons/android-chrome-72x72.png', sizes: '72x72', type: 'image/png' },
    { src: '/img/icons/android-chrome-96x96.png', sizes: '96x96', type: 'image/png' },
    { src: '/img/icons/android-chrome-128x128.png', sizes: '128x128', type: 'image/png' },
    { src: '/img/icons/android-chrome-144x144.png', sizes: '144x144', type: 'image/png' },
    { src: '/img/icons/android-chrome-152x152.png', sizes: '152x152', type: 'image/png' },
    { src: '/img/icons/android-chrome-192x192.png', sizes: '192x192', type: 'image/png', purpose: 'any maskable' },
    { src: '/img/icons/android-chrome-384x384.png', sizes: '384x384', type: 'image/png' },
    { src: '/img/icons/android-chrome-512x512.png', sizes: '512x512', type: 'image/png', purpose: 'any maskable' },
  ],
  colors: {
    light: {
      primary: '#ce0071',
      primaryRgb: '206, 0, 113',
      success: '#06d6a0',
      successHover: '#05b98a',
      loaderPrimary: '#d946ef',
      loaderSecondary: '#a855f7',
    },
    dark: {
      primary: '#ce0071',
      primaryRgb: '206, 0, 113',
      success: '#06d6a0',
      successHover: '#08be8e',
      loaderPrimary: '#d946ef',
      loaderSecondary: '#a855f7',
    },
  },
  gradients: {
    primary: 'linear-gradient(135deg, #e91e8c, #c2185b)',
    chatBubbleSent: {
      light: 'linear-gradient(90deg, #e463009b, #ce0071)',
      dark: 'linear-gradient(90deg, #ce0071, #e46300bb)',
    },
  },
  loginAssets: {
    backgroundImage: 'https://homologacao.whiz.app.br/assets/images/bg-auth.png',
    overlayGradient: 'linear-gradient(45deg, rgba(206, 0, 113, 0.85), rgba(255, 167, 35, 0.78))',
  },
  images: {
    emptyChat: '/img/celular.png',
    emptyChatTeam: '/img/celular_team.png',
    chatWallpaper: '/img/fundo.png',
    avatarFallback: '/img/empty.png',
    avatarFallbackGroup: '/img/empty_group.png',
    communicationEmpty: '/img/comunicacao_empty.gif',
  },
  texts: {
    loginFooterAdmin: '© {year} Whiz Admin. Acesso monitorado.',
    loginFooterUser: '© {year} Whiz. Todos os direitos reservados.',
    installAppButton: 'Instalar Aplicativo Whiz',
    loadingApp: 'Carregando Whiz...',
    welcomeChatTitle: 'Seja bem-vindo ao Whiz',
    welcomeChatText: 'O Whiz ajuda você a organizar, acompanhar e gerenciar seus atendimentos em um só lugar.',
  },
};
